import React, {useState} from 'react';
import './App.css';
import 'antd/dist/antd.css';
import { Layout, Row, Col } from 'antd';
import logo from './asset/logo-about.png'
const { Header, Content } = Layout;


function App() {
return (
    <div >
        <Header style={{backgroundColor: "#FFF"}}>
            <a href="https://dict-52c9a.web.app">
                <img style={{width: "220px"}} src={logo} alt="Logo"/>
            </a>
        </Header>
        <Content>
            <div className="App">
                <h1>About us</h1>
                <Row>
                    <Col span= {6}></Col>
                    <Col span= {12} style={{textAlign: "left"}}>
                        <p>和語―漢語辞典 หรือพจนานุกรมคำกริยาญี่ปุ่น – คำจีน (漢語) เป็นโปรเจ็กต์ในรายวิชาภาษาศาสตร์ภาษาญี่ปุ่นประยุกต์ (2223332) คณะอักษรศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย ภาคการศึกษาปลาย 　ปีการศึกษา 2562 </p>
                        <p>和語―漢語辞典จัดทำขึ้นโดยมีจุดประสงค์เพื่อให้ผู้เรียนภาษาญี่ปุ่นระดับกลาง – ระดับสูง ค้นหาคำกริยา 漢語สำหรับใช้ในงานเขียน เช่น เรียงความ งานเขียนภาษาทางการ เป็นต้น พจนานุกรมนี้ได้รวบรวมคำกริยา 二字漢語 ที่มีการใช้งานมากที่สุด 500 อันดับแรกในหมวดข่าวสังคม (社会) จากเว็บไซต์ NHK NEWS WEB โดยคุณโนโซมิ ยามาดะ ผู้จัดทำเลือกหมวดข่าวสังคมเพื่อความหลากหลายของคำศัพท์ แปลความหมายของคำศัพท์เป็นภาษาไทย รวบรวมรูปประโยค และตัวอย่างประโยค เพื่อให้ผู้ใช้งานสามารถค้นหาได้อย่างมีประสิทธิภาพและรวดเร็ว</p>
                        <h1>วิธีการใช้งาน</h1>
                        <p>ให้ผู้ใช้พิมพ์คำกริยาพื้นฐานง่าย ๆ ที่มีความหมายใกล้เคียงกับคำ 漢語 ที่ต้องการค้นหา โดยสามารถใช้ตัวอักษรฮิรางะนะหรือคันจิในการเสิร์ชได้</p>
                        <h2>ตัวอย่าง</h2>
                        <p>        เมื่อเสิร์ชว่า うごく หรือ 動く จะได้ผลลัพธ์เป็นคำศัพท์ 漢語 ที่มีความหมายใกล้เคียงกับคำที่ใช้เสิร์ช ได้แก่คำว่า 移動、活動、行動 โดยคำศัพท์แต่ละคำจะประกอบไปด้วย </p>
                        <p>1)	ความหมาย</p>
                        <p>2)	รูปประโยค</p>
                        <p>3)	ตัวอย่างประโยค</p>
                        <p>        ผู้ใช้สามารถกดดูความหมายของคำศัพท์ที่สนใจได้หลายคำพร้อม ๆ กัน แล้วเปรียบเทียบความหมายและตัวอย่างการใช้งาน เพื่อให้เลือกใช้คำศัพท์ได้อย่างถูกต้อง</p>
                        <h1>แหล่งข้อมูล</h1>
                        <h2>คำศัพท์</h2>
                        <p>・คำกริยา 漢語 ในพจนานุกรมนี้ เป็นคำที่มีความถี่ในการใช้งานสูงสุด 500 อันดับแรก ในข่าวหมวดสังคม (社会) จากเว็บไซต์ NHK NEWS WEB จำนวน 1,441 ข่าว </p>
                        <h2>ความหมาย วิธีการใช้งาน ตัวอย่างประโยค</h2>
                        <p>・国立国語研究所</p>
                        <p>・三省堂 Web Dictionary</p>
                        <p>・スーパー大辞林</p>
                        <p>・Goo辞書</p>
                        <p>・Jisho.org</p>
                        <p>・Weblio辞書: 英和辞典・和英辞典</p>
                    </Col>
                </Row>
                <Row>
                <Col span= {6}></Col>
                <Col span= {12} style={{textAlign: "right"}}>
                    <h2>ทีมผู้จัดทำ</h2>
                    <p>・กวิสรา เหลืองอบอุ่น</p>
                    <p>・พัทธนันท์ เกาะแก้ว</p>
                    <p>Twitter: @n__nudee</p>
                </Col>
                </Row>
            </div>
        </Content>
    </div>
  );
}

export default App;
